<template>
  <div class="login-container">
    <h2 class="text-center mb-4">Iniciar sesión</h2>
    <form @submit.prevent="handleSubmit">
      <div class="mb-3">
        <label for="usuario" class="form-label">Usuario</label>
        <input type="text" class="form-control" id="usuario" v-model="usuario" required>
      </div>
      <div class="mb-3">
        <label for="clave" class="form-label">Contraseña</label>
        <input type="password" class="form-control" id="clave" v-model="clave" required>
      </div>
      <div class="mb-3">
        <label for="idAplicacion" class="form-label">ID Aplicación</label>
        <input type="text" class="form-control" id="idAplicacion" v-model="idAplicacion" required>
      </div>
      <button type="submit" class="btn btn-primary w-100">Iniciar sesión</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      usuario: '',
      clave: '',
      idAplicacion: ''
    }
  },
  methods: {
    async handleSubmit() {
      try {
        const response = await fetch('http://localhost:3000/api/LoginUsuario', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            usuario: this.usuario, 
            clave: this.clave, 
            idAplicacion: this.idAplicacion 
          })
        });

        if (response.ok) {
          const data = await response.json();
          alert(`Token obtenido: ${data.token}`);
        } else {
          alert('Error en las credenciales');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Error al conectar con el servidor');
      }
    }
  }
}
</script>

<style scoped>
/* .login-container {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.2);
  z-index: 10;
  position: relative;
}
.btn-primary {
  background-color: #00b300;
  border-color: #008000;
}
.btn-primary:hover {
  background-color: #008000;
  border-color: #006400;
} */
</style>